/** Проверяет является ли переданное значение числом */
export const isNumber = (value: unknown): value is number => typeof value === 'number';
